"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@headlessui/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _SelectList = _interopRequireDefault(require("react-widgets/lib/SelectList"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _enlarge = _interopRequireDefault(require("cccisd-icons/enlarge7"));
var _shrink = _interopRequireDefault(require("cccisd-icons/shrink7"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _sort = _interopRequireDefault(require("cccisd-icons/sort"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _ReorderQuests = _interopRequireDefault(require("./ReorderQuests"));
var _ReorderDeployments = _interopRequireDefault(require("./ReorderDeployments"));
var _admin = require("../../selectors/admin.js");
var _admin2 = require("../../reducers/admin.js");
var _FilterBlock = _interopRequireDefault(require("../FilterBlock"));
var _cccisdDetectClickLocation = _interopRequireDefault(require("cccisd-detect-click-location"));
var _style = _interopRequireDefault(require("./style.css"));
var _CycleCard = require("../../pages/Deploy/CycleList/CycleCard");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AppDefs = window.cccisd.appDefs;
var Fortress = window.cccisd.fortress;
var Header = function Header(_ref) {
  var organizationList = _ref.organizationList,
    projectList = _ref.projectList,
    project = _ref.project,
    assignment = _ref.assignment,
    selectedDeploymentIds = _ref.selectedDeploymentIds,
    currentDeployment = _ref.currentDeployment,
    surveyHandles = _ref.surveyHandles,
    dispatch = _ref.dispatch,
    leftSection = _ref.leftSection,
    rightSection = _ref.rightSection,
    setExpandedAll = _ref.setExpandedAll,
    match = _ref.match,
    history = _ref.history,
    filter = _ref.filter,
    changeFilter = _ref.changeFilter,
    _ref$showQuestCount = _ref.showQuestCount,
    showQuestCount = _ref$showQuestCount === void 0 ? true : _ref$showQuestCount,
    isExported = _ref.isExported,
    customSwitchProject = _ref.customSwitchProject,
    labelForProject = _ref.labelForProject,
    labelForProjectPlural = _ref.labelForProjectPlural,
    _ref$limitProjectsByP = _ref.limitProjectsByPermissions,
    limitProjectsByPermissions = _ref$limitProjectsByP === void 0 ? [] : _ref$limitProjectsByP,
    _ref$projectIdWhiteli = _ref.projectIdWhitelist,
    projectIdWhitelist = _ref$projectIdWhiteli === void 0 ? null : _ref$projectIdWhiteli,
    _ref$showProjectDropd = _ref.showProjectDropdown,
    showProjectDropdown = _ref$showProjectDropd === void 0 ? false : _ref$showProjectDropd,
    _ref$allowAllQuests = _ref.allowAllQuests,
    allowAllQuests = _ref$allowAllQuests === void 0 ? false : _ref$allowAllQuests,
    _ref$assignmentIdWhit = _ref.assignmentIdWhitelist,
    assignmentIdWhitelist = _ref$assignmentIdWhit === void 0 ? null : _ref$assignmentIdWhit,
    customSwitchQuest = _ref.customSwitchQuest,
    _ref$labelForQuest = _ref.labelForQuest,
    labelForQuest = _ref$labelForQuest === void 0 ? 'Quest' : _ref$labelForQuest,
    _ref$showQuestDropdow = _ref.showQuestDropdown,
    showQuestDropdown = _ref$showQuestDropdow === void 0 ? false : _ref$showQuestDropdow,
    currentDeploymentId = _ref.currentDeploymentId,
    customSwitchDeployment = _ref.customSwitchDeployment,
    _ref$deploymentDropdo = _ref.deploymentDropdownNotMulti,
    deploymentDropdownNotMulti = _ref$deploymentDropdo === void 0 ? false : _ref$deploymentDropdo,
    _ref$deploymentDropdo2 = _ref.deploymentDropdownSingleType,
    deploymentDropdownSingleType = _ref$deploymentDropdo2 === void 0 ? false : _ref$deploymentDropdo2,
    _ref$labelForDeployme = _ref.labelForDeployment,
    labelForDeployment = _ref$labelForDeployme === void 0 ? 'Data Collection Wave' : _ref$labelForDeployme,
    _ref$showDeploymentDr = _ref.showDeploymentDropdown,
    showDeploymentDropdown = _ref$showDeploymentDr === void 0 ? false : _ref$showDeploymentDr,
    _ref$deploymentIdWhit = _ref.deploymentIdWhitelist,
    deploymentIdWhitelist = _ref$deploymentIdWhit === void 0 ? null : _ref$deploymentIdWhit,
    _ref$showRepeatableDe = _ref.showRepeatableDeploymentChildren,
    showRepeatableDeploymentChildren = _ref$showRepeatableDe === void 0 ? true : _ref$showRepeatableDe,
    _ref$allowAllSurveys = _ref.allowAllSurveys,
    allowAllSurveys = _ref$allowAllSurveys === void 0 ? true : _ref$allowAllSurveys,
    customSwitchSurvey = _ref.customSwitchSurvey,
    _ref$labelForSurvey = _ref.labelForSurvey,
    labelForSurvey = _ref$labelForSurvey === void 0 ? 'Survey' : _ref$labelForSurvey,
    _ref$showSurveyDropdo = _ref.showSurveyDropdown,
    showSurveyDropdown = _ref$showSurveyDropdo === void 0 ? false : _ref$showSurveyDropdo,
    surveyDropdownVisible = _ref.surveyDropdownVisible,
    setSurveyDropdownVisible = _ref.setSurveyDropdownVisible;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    deploymentDropdownVisible = _useState2[0],
    setDeploymentDropdownVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    deploymentSearchTerm = _useState4[0],
    setDeploymentSearchTerm = _useState4[1];
  var questCount = (0, _get2["default"])(project, 'flows.assignmentList.length', 0);
  var getProjectLabel = function getProjectLabel(plural) {
    var hasLabelProp = plural && labelForProjectPlural || !plural && labelForProject;
    if (hasLabelProp) {
      return plural ? labelForProjectPlural : labelForProject;
    }
    var questProjectSettings = AppDefs.pawn.groups.find(function (item) {
      return item.handle === 'questproject';
    });
    if (questProjectSettings) {
      return plural ? questProjectSettings.labelPlural : questProjectSettings.label;
    }
    return plural ? 'Quest Projects' : 'Quest Project';
  };
  function switchProject(_x) {
    return _switchProject.apply(this, arguments);
  }
  function _switchProject() {
    _switchProject = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
      var newProjectId;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            newProjectId = Number(event.target.value);
            if (!(newProjectId === project.projectId)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            if (!customSwitchProject) {
              _context3.n = 3;
              break;
            }
            _context3.n = 2;
            return customSwitchProject(newProjectId);
          case 2:
            return _context3.a(2);
          case 3:
            // replace :projectId and remove all other params
            history.push(match.path.replace(/:projectId\??/, newProjectId).replace(/\/?:[\w\d]+\??/gi, ''));
          case 4:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _switchProject.apply(this, arguments);
  }
  var assignments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectAssignments)(state.assignment.admin);
  });
  var activeAssignments = assignments.filter(function (item) {
    return !item.archived && (!Array.isArray(assignmentIdWhitelist) || assignmentIdWhitelist.map(function (i) {
      return Number.parseInt(i, 10);
    }).includes(Number.parseInt(item.assignmentId, 10)));
  });
  function switchAssignment(_x2) {
    return _switchAssignment.apply(this, arguments);
  }
  function _switchAssignment() {
    _switchAssignment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(event) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (!customSwitchQuest) {
              _context4.n = 2;
              break;
            }
            _context4.n = 1;
            return customSwitchQuest(event.target.value);
          case 1:
            return _context4.a(2);
          case 2:
            _context4.n = 3;
            return dispatch((0, _admin2.setCurrentAssignmentId)(Number(event.target.value)));
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _switchAssignment.apply(this, arguments);
  }
  var deployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentAssignmentDeployments)(state.assignment.admin);
  });
  var activeDeployments = deployments.filter(function (item) {
    return !item.archived && (showRepeatableDeploymentChildren || !item.parentDeploymentId) && (!Array.isArray(deploymentIdWhitelist) || deploymentIdWhitelist.map(function (i) {
      return Number.parseInt(i, 10);
    }).includes(Number.parseInt(item.deploymentId, 10)));
  });
  var filteredActiveDeployments = deploymentSearchTerm === '' ? activeDeployments : activeDeployments.filter(function (deployment) {
    return deployment.label.toLowerCase().includes(deploymentSearchTerm.toLowerCase());
  });
  function switchSurveyHandleMulti(_x3) {
    return _switchSurveyHandleMulti.apply(this, arguments);
  }
  function _switchSurveyHandleMulti() {
    _switchSurveyHandleMulti = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(value) {
      var handles;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            handles = value.map(function (item) {
              return (0, _get2["default"])(item, 'surveyHandle', item);
            });
            dispatch((0, _admin2.setCurrentSurveyHandles)(handles));
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return _switchSurveyHandleMulti.apply(this, arguments);
  }
  var selectedDeployments = activeDeployments.filter(function (item) {
    return selectedDeploymentIds.includes(item.deploymentId);
  });
  var selectedDeploymentType = selectedDeployments.length > 0 ? selectedDeployments[0].type : null;
  var deploymentClosedRoster = selectedDeployments.length > 0 ? selectedDeployments[0].settings.closedRoster : false;

  // there could be a deployment set in state, but if no deployment dropdown
  // we want the survey dropdown to reflect all surveys in the assignment
  var assignmentSurveys = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentAssignmentSurveys)(state.assignment.admin);
  });
  var activeSurveys = (0, _sortBy2["default"])((0, _uniqBy2["default"])(assignmentSurveys.filter(function (s) {
    return !s.archived;
  }), 'surveyHandle'), 'position');
  function setCheckedSurveysByDeployments(deploymentIds) {
    var _ref2, _ref3;
    var currentCheckedSurveyHandles = surveyHandles;
    var currentCheckedDeployments = deployments.filter(function (item) {
      return selectedDeploymentIds.includes(item.deploymentId);
    });
    var currentHandles = currentCheckedDeployments.map(function (item) {
      return (0, _get2["default"])(item, 'settings.options', []);
    });
    var currentUniqueSurveyHandles = (0, _uniq2["default"])((_ref2 = []).concat.apply(_ref2, _toConsumableArray(currentHandles)));
    var targetCheckedDeployments = deployments.filter(function (item) {
      return deploymentIds.includes(item.deploymentId);
    });
    var targetHandles = targetCheckedDeployments.map(function (item) {
      return (0, _get2["default"])(item, 'settings.options', []);
    });
    var targetUniqueSurveyHandles = (0, _uniq2["default"])((_ref3 = []).concat.apply(_ref3, _toConsumableArray(targetHandles)));
    if (currentCheckedSurveyHandles.length === 0 || (0, _isEmpty2["default"])((0, _xor2["default"])(currentCheckedSurveyHandles, currentUniqueSurveyHandles))) {
      switchSurveyHandleMulti((0, _intersection2["default"])(targetUniqueSurveyHandles, activeSurveys.map(function (s) {
        return s.surveyHandle;
      })));
    }
  }
  var assignmentDisplayName = labelForQuest !== null ? labelForQuest : (0, _get2["default"])(AppDefs, 'app.vocabulary.assignment', 'Quest');
  var deploymentDisplayName = labelForDeployment !== null ? labelForDeployment : (0, _get2["default"])(AppDefs, 'app.vocabulary.deployment', 'Data Collection Wave');
  var surveyDisplayName = labelForSurvey !== null ? labelForSurvey : (0, _get2["default"])(AppDefs, 'app.vocabulary.survey', 'Survey');
  var disabledDeploymentIds = !deploymentDropdownSingleType || selectedDeploymentType === null ? [] : activeDeployments.filter(function (item) {
    return item.type !== selectedDeploymentType || item.settings.closedRoster !== deploymentClosedRoster;
  }).map(function (item) {
    return item.deploymentId;
  });
  var currentDeploymentIds = selectedDeploymentIds.filter(function (item) {
    return !disabledDeploymentIds.includes(item);
  });
  function switchDeploymentMulti(value) {
    var deploymentIds = value.map(function (item) {
      return item.deploymentId;
    });
    var current = _toConsumableArray(deploymentIds);

    // If dropdown is restricted to a single type AND there is at least one
    // deployment selected, then there might be deployments to disable
    if (deploymentDropdownSingleType && value.length) {
      var selected = activeDeployments.filter(function (item) {
        return deploymentIds.includes(item.deploymentId);
      });
      if (selected.length) {
        var deploymentType = selected[0].type;
        var closedRoster = selected[0].settings.closedRoster;
        var disabled = activeDeployments.filter(function (item) {
          return item.type !== deploymentType || item.settings.closedRoster !== closedRoster;
        }).map(function (item) {
          return item.deploymentId;
        });
        current = deploymentIds.filter(function (item) {
          return !disabled.includes(item);
        });
      }
    }
    if (showSurveyDropdown) {
      setCheckedSurveysByDeployments(deploymentIds);
    }
    dispatch((0, _admin2.setSelectedDeploymentIds)(deploymentIds));
    dispatch((0, _admin2.setCurrentDeploymentIds)(current));
  }
  function switchDeploymentSingle(value) {
    dispatch((0, _admin2.setSelectedDeploymentIds)([Number(value)]));
    dispatch((0, _admin2.setCurrentDeploymentIds)([Number(value)]));
  }
  function getDeploymentButtonLabel() {
    if (activeDeployments.length === 0) {
      return "No ".concat(deploymentDisplayName, " to select");
    }
    if (currentDeploymentIds.length === 1) {
      var d = activeDeployments.find(function (item) {
        return item.deploymentId === currentDeploymentIds[0];
      });
      return d ? getDeploymentLabel(d) : '';
    }
    return "".concat(currentDeploymentIds.length, " selected");
  }
  function getSurveyButtonLabel() {
    if (surveyHandles.length === 1) {
      var s = activeSurveys.find(function (item) {
        return item.surveyHandle === surveyHandles[0];
      });
      return s ? s.label : '';
    }
    return "".concat(surveyHandles.length || 'All', " selected");
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function renderProjectDropdown() {
    if (!showProjectDropdown) {
      return null;
    }
    var narrowedProjectList = !Array.isArray(projectIdWhitelist) ? projectList : projectList.filter(function (p) {
      return projectIdWhitelist.map(function (i) {
        return Number.parseInt(i, 10);
      }).includes(Number.parseInt(p.groupId, 10));
    });
    narrowedProjectList = narrowedProjectList.filter(function (p) {
      return !isExported || project && p.groupId === project.groupId || Fortress.hasAnyAccess(limitProjectsByPermissions, p.groupId);
    });
    if (narrowedProjectList.length === 0) {
      return /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        style: {
          width: 'auto',
          maxWidth: '200px'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement("option", null, "There are no ", getProjectLabel(true)));
    }
    var usedOrganizations = narrowedProjectList.reduce(function (list, item) {
      list.add(item.organizationId);
      return list;
    }, new Set());
    var isOneOrganization = usedOrganizations.size === 1;
    var options;
    if (isOneOrganization) {
      options = narrowedProjectList.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: item.groupId,
          value: item.groupId
        }, item.label);
      });
    } else {
      options = organizationList.filter(function (org) {
        return usedOrganizations.has(org.groupId);
      }).map(function (org) {
        return /*#__PURE__*/_react["default"].createElement("optgroup", {
          key: org.groupId,
          label: org.label
        }, narrowedProjectList.filter(function (pr) {
          return pr.organizationId === org.groupId;
        }).map(function (pr) {
          return /*#__PURE__*/_react["default"].createElement("option", {
            key: pr.groupId,
            value: pr.groupId
          }, pr.label);
        }));
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label",
      htmlFor: "cccisd-assignment-project-dropdown"
    }, getProjectLabel()), /*#__PURE__*/_react["default"].createElement("select", {
      id: "cccisd-assignment-project-dropdown",
      className: "form-select",
      style: {
        width: 'auto',
        maxWidth: '200px'
      },
      value: project && project.groupId || 0,
      onChange: switchProject
    }, options));
  }
  var renderExpandCollapseButtons = questCount > 0 && setExpandedAll ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: 'btn btn-secondary ' + _style["default"].button,
    id: "cccisd-expand-all-button",
    onClick: function onClick() {
      return dispatch(setExpandedAll(true));
    },
    title: "Expand All"
  }, /*#__PURE__*/_react["default"].createElement(_enlarge["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: 'btn btn-secondary ' + _style["default"].button,
    id: "cccisd-collapse-all-button",
    onClick: function onClick() {
      return dispatch(setExpandedAll(false));
    },
    title: "Collapse All"
  }, /*#__PURE__*/_react["default"].createElement(_shrink["default"], null)), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn btn-secondary ' + _style["default"].button,
      title: "Reorder Quests"
    }, /*#__PURE__*/_react["default"].createElement(_sort["default"], null)),
    title: "Reorder Quests",
    render: function render(_ref4) {
      var closeModal = _ref4.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_ReorderQuests["default"], {
        assignments: activeAssignments,
        onSubmit: (/*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(updatedAssignments) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return dispatch((0, _admin2.reorderAssignmentsAndSave)(updatedAssignments));
                case 1:
                  closeModal();
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x4) {
            return _ref5.apply(this, arguments);
          };
        }())
      });
    },
    modalClassName: _style["default"].noAnimationModal
  })) : null;
  var renderQuestDropdown = !showQuestDropdown ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label",
    htmlFor: "cccisd-assignment-assignment-dropdown"
  }, assignmentDisplayName), /*#__PURE__*/_react["default"].createElement("select", {
    className: "form-select",
    disabled: !activeAssignments.length,
    id: "cccisd-assignment-assignment-dropdown",
    onChange: switchAssignment,
    style: {
      width: 'auto',
      maxWidth: '200px'
    },
    value: assignment ? assignment.assignmentId : 0
  }, allowAllQuests && /*#__PURE__*/_react["default"].createElement("option", {
    key: "all_assignments",
    value: "0"
  }, "All ", assignmentDisplayName, "s"), activeAssignments.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: item.assignmentId,
      value: item.assignmentId
    }, item.label);
  }), activeAssignments.length === 0 && /*#__PURE__*/_react["default"].createElement("option", {
    key: "empty",
    value: ""
  }, "No ", assignmentDisplayName, " to select")));
  function getDeploymentLabel(item) {
    var label = item === null || item === void 0 ? void 0 : item.label;
    if (!label) {
      if (item !== null && item !== void 0 && item.parentDeploymentId) {
        var parent = activeDeployments.find(function (d) {
          return d.deploymentId === Number(item.parentDeploymentId);
        });
        label = parent ? parent.label : '';
      }
      if (!label) {
        // some other type of programmatically created deployment
        label = "".concat(item === null || item === void 0 ? void 0 : item.assignment.label, " (").concat(item === null || item === void 0 ? void 0 : item.type, " ").concat(item === null || item === void 0 ? void 0 : item.hash, ")");
      }
    }
    if (item !== null && item !== void 0 && item.timepoint && !(item !== null && item !== void 0 && item.parentDeploymentId)) {
      label += ' - Timepoint ' + item.timepoint;
    }
    return label;
  }
  function renderDeploymentDropdown() {
    if (!showDeploymentDropdown) {
      return null;
    }
    if (deploymentDropdownNotMulti) {
      return activeDeployments.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, deploymentDisplayName), /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        style: {
          width: 'auto',
          maxWidth: '200px'
        },
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement("option", null, "No ", deploymentDisplayName, " to select"))) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'flex-end',
          gap: '0.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_react2.Combobox, {
        as: "div",
        id: "cccisd-assignment-deployment-dropdown",
        value: currentDeploymentId,
        onChange: switchDeploymentSingle
      }, /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Label, {
        className: "form-label"
      }, deploymentDisplayName), /*#__PURE__*/_react["default"].createElement("div", {
        className: "input-group"
      }, /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Input, {
        className: "form-control",
        onFocus: function onFocus(event) {
          return event.target.select();
        },
        displayValue: function displayValue() {
          return getDeploymentLabel(currentDeployment);
        },
        onChange: function onChange(event) {
          return setDeploymentSearchTerm(event.target.value);
        }
      }), /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Button, {
        className: "btn btn-secondary",
        onClick: function onClick() {
          return setDeploymentSearchTerm('');
        }
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Options, {
        style: {
          position: 'absolute',
          backgroundColor: 'white',
          zIndex: 99999,
          marginTop: '1em',
          boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
          width: '100%',
          maxWidth: '60vw',
          maxHeight: '50vh',
          listStyleType: 'none',
          borderRadius: '1rem',
          border: '1px solid lightgray',
          padding: '0',
          overflowX: 'scroll'
        }
      }, filteredActiveDeployments.map(function (item, i) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: item.deploymentId
        }, i !== 0 && /*#__PURE__*/_react["default"].createElement("hr", {
          style: {
            margin: '0'
          }
        }), /*#__PURE__*/_react["default"].createElement(_react2.Combobox.Option, {
          key: item.deploymentId,
          value: item.deploymentId,
          style: {
            cursor: 'pointer'
          }
        }, function (_ref6) {
          var selected = _ref6.selected,
            active = _ref6.active;
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              position: 'relative',
              paddingLeft: '4rem',
              backgroundColor: active && 'lightblue'
            }
          }, selected && /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              position: 'absolute',
              left: '2rem',
              top: '1.75rem'
            }
          }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)), /*#__PURE__*/_react["default"].createElement(_CycleCard.CycleCardDetails, {
            cycle: item,
            deployments: activeDeployments
          }));
        }));
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: 'btn btn-secondary ' + _style["default"].reorderButton,
          title: "Reorder Deployments"
        }, /*#__PURE__*/_react["default"].createElement(_sort["default"], null)),
        title: "Reorder Deployments",
        render: function render(_ref7) {
          var closeModal = _ref7.closeModal;
          return /*#__PURE__*/_react["default"].createElement(_ReorderDeployments["default"], {
            deployments: activeDeployments,
            onSubmit: (/*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(updatedDeployments) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return dispatch((0, _admin2.reorderDeploymentsAndSave)(updatedDeployments));
                    case 1:
                      closeModal();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              return function (_x5) {
                return _ref8.apply(this, arguments);
              };
            }())
          });
        },
        modalClassName: _style["default"].noAnimationModal
      }));
    }
    var showAllNoneButtons = deploymentDropdownVisible && activeDeployments.length > 1;
    var allSelectableDeployments = activeDeployments.filter(function (a) {
      return !disabledDeploymentIds.includes(a.deploymentId);
    });
    return /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
      clickedOutside: function clickedOutside() {
        return setDeploymentDropdownVisible(false);
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "cccisd-assignment-deployment-dropdown"
    }, deploymentDisplayName), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: getDeploymentButtonLabel(),
      className: "btn btn-secondary",
      onClick: function onClick() {
        return setDeploymentDropdownVisible(!deploymentDropdownVisible);
      },
      style: {
        display: 'block',
        width: '100%',
        textAlign: 'left'
      }
    }), showAllNoneButtons && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: 'absolute'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-secondary",
      isDisabled: allSelectableDeployments.length === selectedDeploymentIds.length,
      onClick: function onClick() {
        return switchDeploymentMulti(allSelectableDeployments);
      },
      title: "Select All"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-secondary",
      isDisabled: selectedDeploymentIds.length === 0,
      onClick: function onClick() {
        return switchDeploymentMulti([]);
      },
      title: "Deselect All"
    })), /*#__PURE__*/_react["default"].createElement(_SelectList["default"], {
      multiple: true,
      data: activeDeployments,
      disabled: disabledDeploymentIds,
      textField: function textField(item) {
        return getDeploymentLabel(item);
      },
      valueField: "deploymentId",
      onChange: switchDeploymentMulti,
      value: selectedDeploymentIds,
      style: {
        display: deploymentDropdownVisible ? 'block' : 'none',
        height: 'auto',
        marginTop: showAllNoneButtons ? '2.5rem' : 0,
        position: 'absolute',
        zIndex: 10
      }
    }));
  }
  function renderSurveyDropdown() {
    if (!showSurveyDropdown) {
      return null;
    }
    var showAllNoneButtons = surveyDropdownVisible && activeSurveys.length > 1;
    var surveyDropdownData = activeSurveys.map(function (item) {
      return {
        surveyHandle: item.surveyHandle,
        surveyLabel: item.label
      };
    });
    return /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
      clickedOutside: function clickedOutside() {
        return setSurveyDropdownVisible(false);
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label",
      htmlFor: "cccisd-assignment-survey-dropdown"
    }, surveyDisplayName), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: getSurveyButtonLabel(),
      className: "btn btn-secondary",
      onClick: function onClick() {
        return setSurveyDropdownVisible(!surveyDropdownVisible);
      },
      style: {
        display: 'block',
        maxWidth: '400px',
        whiteSpace: 'normal'
      }
    }), showAllNoneButtons && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: 'absolute'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-secondary",
      isDisabled: surveyDropdownData.length === surveyHandles.length,
      onClick: function onClick() {
        setSurveyDropdownVisible(false);
        switchSurveyHandleMulti(surveyDropdownData);
      },
      title: "Select All"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      className: "btn btn-xs btn-secondary",
      isDisabled: surveyHandles.length === 0,
      onClick: function onClick() {
        setSurveyDropdownVisible(false);
        switchSurveyHandleMulti([]);
      },
      title: "Deselect All"
    })), /*#__PURE__*/_react["default"].createElement(_SelectList["default"], {
      multiple: true,
      data: surveyDropdownData,
      textField: "surveyLabel",
      valueField: "surveyHandle",
      onChange: switchSurveyHandleMulti,
      value: surveyHandles,
      style: {
        display: surveyDropdownVisible ? 'block' : 'none',
        height: 'auto',
        marginTop: showAllNoneButtons ? '2.5rem' : 0,
        position: 'absolute',
        zIndex: 11
      }
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, renderProjectDropdown(), showQuestCount && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].count
  }, "Quests (", questCount, ")"), renderExpandCollapseButtons, changeFilter && /*#__PURE__*/_react["default"].createElement(_FilterBlock["default"], {
    value: filter,
    onChange: function onChange(value) {
      return dispatch(changeFilter(value));
    }
  }), renderQuestDropdown, renderDeploymentDropdown(), renderSurveyDropdown(), leftSection && /*#__PURE__*/_react["default"].createElement("div", null, leftSection), rightSection && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].rightSection
  }, rightSection)));
};
Header.propTypes = {
  organizationList: _propTypes["default"].array,
  projectList: _propTypes["default"].array,
  project: _propTypes["default"].object,
  assignment: _propTypes["default"].object,
  selectedDeploymentIds: _propTypes["default"].array,
  currentDeployment: _propTypes["default"].object,
  surveyHandles: _propTypes["default"].array,
  dispatch: _propTypes["default"].func,
  leftSection: _propTypes["default"].node,
  rightSection: _propTypes["default"].node,
  setExpandedAll: _propTypes["default"].func,
  match: _propTypes["default"].object,
  history: _propTypes["default"].object,
  filter: _propTypes["default"].string,
  changeFilter: _propTypes["default"].func,
  showQuestCount: _propTypes["default"].bool,
  isExported: _propTypes["default"].bool,
  customSwitchProject: _propTypes["default"].func,
  labelForProject: _propTypes["default"].string,
  labelForProjectPlural: _propTypes["default"].string,
  limitProjectsByPermissions: _propTypes["default"].array,
  projectIdWhitelist: _propTypes["default"].array,
  showProjectDropdown: _propTypes["default"].bool,
  allowAllQuests: _propTypes["default"].bool,
  assignmentIdWhitelist: _propTypes["default"].array,
  customSwitchQuest: _propTypes["default"].func,
  labelForQuest: _propTypes["default"].string,
  showQuestDropdown: _propTypes["default"].bool,
  currentDeploymentId: _propTypes["default"].number,
  customSwitchDeployment: _propTypes["default"].func,
  deploymentDropdownNotMulti: _propTypes["default"].bool,
  deploymentDropdownSingleType: _propTypes["default"].bool,
  labelForDeployment: _propTypes["default"].string,
  showDeploymentDropdown: _propTypes["default"].bool,
  deploymentIdWhitelist: _propTypes["default"].array,
  showRepeatableDeploymentChildren: _propTypes["default"].bool,
  allowAllSurveys: _propTypes["default"].bool,
  customSwitchSurvey: _propTypes["default"].func,
  labelForSurvey: _propTypes["default"].string,
  showSurveyDropdown: _propTypes["default"].bool,
  surveyDropdownVisible: _propTypes["default"].bool,
  setSurveyDropdownVisible: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    assignment: (0, _admin.getCurrentAssignment)(state.assignment.admin),
    currentDeploymentId: state.assignment.admin.currentDeploymentIds.length ? state.assignment.admin.currentDeploymentIds[0] : 0,
    currentDeployment: (0, _admin.getCurrentDeployment)(state.assignment.admin),
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    organizationList: state.assignment.admin.organizationList,
    projectList: state.assignment.admin.projectList,
    selectedDeploymentIds: state.assignment.admin.selectedDeploymentIds,
    surveyHandles: state.assignment.admin.currentSurveyHandles
  };
})(Header));